import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Dropdown, notification, Select, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import DeleteConfirmation from "../../../components/common/ConfirmationModal/DeleteConfirmation";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import VideoFilm from "../../../components/icons/VideoFilm";
import VideoGroup from "../../../components/icons/VideoGroup";
import { addSubClient } from "../../../utils/validations";
import EditSubClient from "./EditSubClient";
const AddSubClients = ({ ...props }) => {
  const firstRef = useRef(true);
  const secRef = useRef(true);
  const { Option } = Select;
  const {
    addTenant,
    tenantNames,
    getTenants,
    updateTenant,
    deleteTenant,
    getUserDetail,
    tenantDetails,
    setTenantDetails,
    loder,
    setLoder,
  } = props;
  const [isTenantModalOpen, setIsTenantModalOpen] = useState(false);
  const [editmodalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [disable, setDisable] = useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [clientUser, setClientUser] = useState([]);
  const [clientArray, setClientArray] = useState([]);
  const [count, setCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;

  const openModal = () => {
    setIsTenantModalOpen(true);
  };
  const closeModal = () => {
    setIsTenantModalOpen(false);
    setInitialValues({ name: "", users: [] });
    setClientArray([]);
  };

  const [initialValues, setInitialValues] = useState({
    name: "",
    users: [],
  });

  //   const handlePageChange = (current) => {
  //     setActivePage(current);
  //     setEnd(current * settingsRecordsPerPage);
  //     setStart(current * settingsRecordsPerPage - settingsRecordsPerPage);
  //   };

  const setsubClientName = (e, setFieldValue) => {
    setFieldValue("name", e);
    setInitialValues({ ...initialValues, name: e });
  };

  // const getTenants = async () => {
  //     setLoder(true)
  //     const data = await getTenant();
  //     if (data?.value?.success) {
  //         setTenantNames(data?.value?.data);
  //         setLoder(false)
  //     }
  // };
  const handleSubmit = async ({ name, users }) => {
    setLoder(true);
    const data = await addTenant({
      name,
      associateUsers: clientArray,
    });
    if (data.value.success) {
      notification["success"]({ message: data.value.message });
      setLoder(false);
    } else {
      notification["error"]({ message: data.value.message });
      setLoder(false);
    }

    closeModal();
    getTenants();
  };

  const editOpen = (data) => {
    setEditModalOpen(true);
  };

  const delOpen = (data) => {
    setDeleteModalOpen(true);
  };
  const actions = {
    edit_sub_clients: true,
    delete_sub_clients: true,
  };
  const getUser = async () => {
    const data = await getUserDetail();
    if (data.value.success) {
      //(data.value.users);
      const filterUser = data.value.users.filter((d) => !d.hasOwnProperty("clientId"));
      setClientUser(filterUser);
    }
  };
  const search = async () => {
    const data = await getUserDetail({ search: searchText });
    if (data.value.success) {
      setUserDetails([...data.value.users]);
      const filterUser = data.value.users.filter((d) => !d.hasOwnProperty("clientId"));
      setClientUser(filterUser);
    }
  };
  useEffect(() => {
    if (firstRef.current) {
      search();
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        search();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [count]);
  useEffect(() => {
    if (secRef.current) {
      secRef.current = false;
    } else {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [searchText, setCount]);
  useEffect(() => {
    getTenants();
    getUser();
  }, []);
  const handleTenantTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "edit_sub_clients":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    editOpen(tenantDetails);
                  }}
                >
                  <VideoFilm />
                  <span>Edit</span>
                </a>
              ),
              key: "1",
            });
            break;
          case "delete_sub_clients":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    delOpen(tenantDetails);
                  }}
                >
                  <DeleteIcon />
                  <span>Delete</span>
                </a>
              ),
              key: "2",
            });
            break;
        }
      }
    }
  };
  const deleteFunction = async () => {
    const data = await deleteTenant({ id: tenantDetails._id, associateUsers: tenantDetails?.associateUsers });
    if (data.value.success) {
      notification["success"]({ message: data.value.message });
      getTenants();
    } else {
      notification["error"]({ message: data.value.message });
    }
    setDeleteModalOpen(false);
  };
  const handleClient = async (e, setFieldValue) => {
    setFieldValue("users", e);
    setClientArray(e);
    const data = await getUserDetail();
    if (data.value.success) {
      // setUsersDetails([...data.value.users]);
      const filterUser = data.value.users.filter((d) => !d.hasOwnProperty("clientId"));
      setClientUser(filterUser);
    }
  };
  return (
    <>
      <EditSubClient
        editmodalOpen={editmodalOpen}
        setEditModalOpen={setEditModalOpen}
        tenantDetails={tenantDetails}
        tenantNames={tenantNames}
        addTenant={addTenant}
        updateTenant={updateTenant}
        getTenants={getTenants}
        getUser={getUser}
        userDetails={userDetails}
      />
      <DeleteConfirmation
        deleteConfirmModalOpen={deleteModalOpen}
        setDeleteConfirmModalOpen={setDeleteModalOpen}
        tenantDetails={tenantDetails}
        deleteFunction={deleteFunction}
      />
      <Modal
        isOpen={isTenantModalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <AccessControl code="add_folder" page="organization-profile">
            <div className="react-modal-header">
              <h5 className="react-modal-title">Add Sub Client</h5>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </AccessControl>
          <Formik initialValues={initialValues} validationSchema={addSubClient} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Sub client name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="name"
                        placeholder="Add Client"
                        onChange={(e) => setsubClientName(e.target.value, setFieldValue)}
                      />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="field-items mb-4">
                      <label className="form-label">
                        {" "}
                        Select users<span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          // showSearch
                          className="custom-ant-select"
                          name="users"
                          onChange={(value) => handleClient(value, setFieldValue)}
                          component={Select}
                          mode="multiple"
                          filterOption={false}
                          placeholder="Select Users"
                          onSearch={(inputValue) => setSearchText(inputValue)}
                          dropdownStyle={{ zIndex: 99999999 }}
                          // placeholder="Select Sport"
                          //defaultValue={"Select Users"}
                          value={clientArray}
                        >
                          {clientUser.length > 0 &&
                            clientUser.map((data, index) => {
                              return (
                                <>
                                  <Option key={index} value={data.userId}>
                                    {data.name}-{data.email}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                        {touched.users && errors.users && <div className="invalid-feedback">{errors.users}</div>}
                      </div>
                    </div>
                    <button className="btn btn-primary" type="submit" disabled={disable}>
                      Add
                      {loder === true ? <Spin indicator={antIcon} /> : ""}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <div className="col-md-9">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Sub Clients</h4>
          </div>
          <div className="right-btn-block">
            <div class="button-container">
              <button class="btn btn-primary" onClick={openModal}>
                Add Sub Client
              </button>
            </div>
          </div>
        </div>
        <br />
        <div className="configuration-items-row mt-3 row">
          {tenantNames?.map((data) => {
            return (
              <>
                <div className="col-md-2">
                  <div className="configuration-column pb-0">
                    <Dropdown
                      onClick={() => {
                        setTenantDetails(data);
                      }}
                      className=""
                      overlay={
                        <AccessControl
                          code="menuItem"
                          page="organization-profile"
                          handleTableAction={handleTenantTableAction}
                        />
                      }
                      trigger={["click"]}
                      overlayClassName={"tableActionBlock"}
                      placement={"bottomRight"}
                    >
                      <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                        <TheeDotsIcon />
                      </a>
                    </Dropdown>
                    <div className="icon-block">
                      <VideoGroup />
                    </div>
                    <h4 className="word-break-common">
                      {data?.name
                        .split(" ")
                        .map((letter, index) => letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase())
                        .join(" ")}
                    </h4>
                  </div>
                </div>
              </>
            );
          })}
        </div>
        {/* <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={folderNames?.length}
          className="text-center mt-3"
        /> */}
      </div>
    </>
  );
};
export default AddSubClients;
